import { useState, useEffect, useRef } from "react";
import {PlayArrowRounded} from "@mui/icons-material";
import StateTimeIndicator from "../../components/stateTimeIndicator";
import Thumbnail from "../../components/thumbnail";

function PosterItem({ item, selected, settings, onClick }) {
  return (
    <div className={`flex w-full h-full absolute top-0 left-0 transition-opacity duration-500`} style={{
        opacity: selected?1:0,
        zIndex:selected?10:0
    }}>
      <Thumbnail item={item} settings={settings}/>
      <div className="vf-poster-info absolute flex flex-col left-0 top-0 h-full justify-center items-start w-full xl:w-1/2 px-2 md:px-5 lg:px-10 bg-gradient-to-r from-black/50 to-transparent">
        <StateTimeIndicator className="mb-[1vw] rounded-md" item={item} settings={settings}/>
        {(item.name && settings.showName) &&<span className="vf-poster-title text-white text-[18px] leading-[24px] sm:text-[28px] sm:leading-[32px] md:text-[36px] md:leading-[40px] lg:text-[4vw] lg:leading-[5vw] 2xl:text-[3vw] 2xl:leading-[4vw] font-bold">{item.name}</span>}
        
        {(item.description && settings.showDesc) && <span className="vf-poster-desc text-white text-[18px] md:text-[22px] lg:text-[2vw] 2xl:text-[1.5vw] ">{item.description}</span>}
        
        {(item.state==='live' || item.state==='vod') && 
        <button onClick={()=>onClick(item)} 
          className="vf-poster-button mt-2 z-30 px-2 py-1 lg:px-[1vw] lg:py-[0.5vw] bg-black text-white/70 bg-black/80 rounded-md flex justify-center items-center hover:text-white hover:bg-black/90 
          text-[18px] md:text-[22px] lg:text-[2vw] 2xl:text-[1.5vw] cursor-pointer">
            <PlayArrowRounded fontSize="inherit" className="mr-2" />
            <span className="text-lg font-bold">{settings.cta}</span>
        </button>}
      </div>
    </div>
  );
}

export default PosterItem;
